import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { ActionsModalDto } from 'src/app/dto/shared.dto';
import { RtsGeneratorService } from 'src/app/services/docs-service/rts-generator.service';
import * as Sentry from '@sentry/angular';

export type ActionsModalRole = 'confirm' | 'reject' | 'cancel';

@Component({
  selector: 'app-actions-modal',
  templateUrl: './actions-modal.component.html',
  styleUrls: ['./actions-modal.component.scss']
})
export class ActionsModalComponent<T> {
  @Input() data: ActionsModalDto<T>;
  isToastOpen = false;
  acceptExpeditorTerms = false;
  loading = false;

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    private navCtrl: NavController,
    private rtsGeneratorService: RtsGeneratorService
  ) {}

  getTitleStyles() {
    if (this.data.errorTitle) {
      return {
        color: '#F8627D'
      };
    }
    return {};
  }

  confirm() {
    return this.performAction(this.data?.confirmAction, 'confirm');
  }

  reject() {
    return this.performAction(this.data?.rejectAction, 'reject');
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  openExpeditorTerms() {
    this.router.navigate(['expeditorTerms']);
    this.cancel();
  }

  setOpen(isOpen: boolean) {
    this.isToastOpen = isOpen;
  }

  async exportPDF() {
    this.setOpen(true);
  }

  async exportXLS() {
    if (this.data.carData && this.data.orderData) {
      this.loading = true;
      try {
        await this.rtsGeneratorService.getTtn(
          this.data.carData,
          this.data.orderData
        );
      } catch (error) {
        Sentry.captureException(error);
      } finally {
        this.loading = false;
      }
    }
  }

  private async performAction(
    action?: () => Promise<T>,
    role?: string
  ): Promise<boolean> {
    this.loading = true;
    try {
      let result = null;
      if (action) {
        result = await action();
      }
      return this.modalCtrl.dismiss({ result }, role);
    } catch (error) {
      const statusCode: number = (error as { status: number }).status;
      if (statusCode !== 0) {
        Sentry.captureException(error);
      }
      return this.modalCtrl.dismiss({ error }, role);
    } finally {
      this.loading = false;
    }
  }
}
